import { useI18n } from '../../contexts/I18nContext';
import {
  useClientIndustries,
  useCreateClientIndustry,
  useSetClientIndustry,
} from '../../hooks/useActors';
import { Select } from '../ui/Select';

/**
 * The industry belongs to the CLIENT (two clients in one industry are
 * competitors); an actor only inherits it through the clients they appeared
 * at. Where a client has none, the Actori screens offer this picker so it can
 * be set on the spot, with "add" for a new industry.
 */
export function ClientIndustryPicker({
  clientId,
  className,
}: {
  clientId: string;
  className?: string;
}) {
  const { t } = useI18n();
  const { data: industries, isLoading } = useClientIndustries();
  const create = useCreateClientIndustry();
  const setIndustry = useSetClientIndustry();

  return (
    <Select
      label={t('clients.industry')}
      hideLabel
      size="sm"
      searchable
      value=""
      loading={isLoading}
      disabled={setIndustry.isPending}
      placeholder={t('actors.setIndustry')}
      options={(industries ?? []).map((i) => ({ value: i.id, label: i.name }))}
      onChange={(industryId) => {
        if (industryId) setIndustry.mutate({ clientId, industryId });
      }}
      onCreate={async (name) => {
        const created = await create.mutateAsync(name);
        await setIndustry.mutateAsync({ clientId, industryId: created.id });
        return created.id;
      }}
      width={220}
      className={className}
    />
  );
}
